






// import { useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { Link } from 'react-router-dom';
// import Navbar from '../../components/feature/Navbar';
// import Footer from '../../components/feature/Footer';
// import { testimonialsData } from '../../mocks/testimonials';

// const categories = ['All', 'Investment Banking', 'Investment Management', 'Securities Trading', 'Fixed Income Fund', 'Short Term Bond Fund'];

// const TestimonialCard = ({ testimonial, index }) => (
//   <motion.div
//     layout
//     initial={{ opacity: 0, scale: 0.9 }}
//     animate={{ opacity: 1, scale: 1 }}
//     exit={{ opacity: 0, scale: 0.9 }}
//     transition={{ duration: 0.4, delay: index * 0.05 }}
//     className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-2xl hover:border-primary-orange/30 transition-all duration-500 flex flex-col group"
//   >
//     {/* Quote Icon Decoration */}
//     <div className="mb-6">
//       <div className="w-10 h-10 bg-primary-orange/10 rounded-full flex items-center justify-center group-hover:bg-primary-orange transition-colors duration-300">
//         <i className="ri-double-quotes-l text-xl text-primary-orange group-hover:text-white"></i>
//       </div>
//     </div>

//     {/* Message - The PRD Required Feedback */}
//     <p className="text-gray-700 leading-relaxed text-lg mb-8 font-light italic">
//       "{testimonial.quote}"
//     </p>

//     {/* Client Info - The PRD Required Name & Company */}
//     <div className="mt-auto flex items-center space-x-4">
//       <div className="relative">
//         <img
//           src={testimonial.avatar}
//           alt={testimonial.name}
//           className="w-14 h-14 rounded-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 border-2 border-transparent group-hover:border-primary-orange"
//         />
//       </div>
//       <div>
//         <h4 className="font-bold text-primary-dark text-base uppercase tracking-tight">
//           {testimonial.name}
//         </h4>
//         {testimonial.title && (
//           <p className="text-sm text-primary-orange font-medium">
//             {testimonial.title} {/* This serves as the 'Company' field from PRD */}
//           </p>
//         )}
//       </div>
//     </div>
//   </motion.div>
// );

// const TestimonialsPage = () => {
//   const [activeFilter, setActiveFilter] = useState('All');

//   const filteredData = activeFilter === 'All'
//     ? testimonialsData
//     : testimonialsData.filter(t => t.service === activeFilter);

//   return (
//     <div className="min-h-screen bg-gray-50/50">
//       <Navbar />

//       {/* Modern Minimalist Hero */}
//       <section className="pt-40 pb-20 bg-primary-dark relative overflow-hidden">
//         <div className="absolute top-0 right-0 w-1/3 h-full bg-primary-orange/10 blur-[120px] rounded-full translate-x-1/2"></div>
//         <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
//           <motion.div
//             initial={{ opacity: 0, x: -30 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.8 }}
//             className="max-w-3xl"
//           >
//             <h1 className="text-5xl md:text-7xl font-serif font-bold text-white mb-6">
//               Voices of <span className="text-primary-orange">Trust.</span>
//             </h1>
//             <p className="text-xl text-gray-400 leading-relaxed">
//               We measure our success by the legacies we help build. Read how our tailored financial strategies have impacted institutions and individuals globally.
//             </p>
//           </motion.div>
//         </div>
//       </section>

//       {/* Interactive Filter Section */}
//       <section className="py-12 sticky top-20 z-30 bg-white/80 backdrop-blur-md border-b border-gray-100">
//         <div className="max-w-7xl mx-auto px-6 lg:px-8">
//           <div className="flex items-center justify-between flex-wrap gap-6">
//             <span className="text-xs font-bold uppercase tracking-widest text-gray-500">Filter by Expertise:</span>
//             <div className="flex flex-wrap gap-2">
//               {categories.map((cat) => (
//                 <button
//                   key={cat}
//                   onClick={() => setActiveFilter(cat)}
//                   className={`px-6 py-2 rounded-full text-xs font-bold transition-all duration-300 ${
//                     activeFilter === cat
//                       ? 'bg-primary-dark text-white shadow-lg'
//                       : 'bg-white text-gray-600 border border-gray-200 hover:border-primary-orange hover:text-primary-orange'
//                   }`}
//                 >
//                   {cat}
//                 </button>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Outstanding Grid Layout */}
//       <section className="py-20">
//         <div className="max-w-7xl mx-auto px-6 lg:px-8">
//           <motion.div 
//             layout
//             className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8"
//           >
//             <AnimatePresence>
//               {filteredData.map((testimonial, index) => (
//                 <div key={testimonial.id} className="break-inside-avoid">
//                   <TestimonialCard testimonial={testimonial} index={index} />
//                 </div>
//               ))}
//             </AnimatePresence>
//           </motion.div>

//           {filteredData.length === 0 && (
//             <motion.div 
//               initial={{ opacity: 0 }} 
//               animate={{ opacity: 1 }} 
//               className="text-center py-40"
//             >
//               <i className="ri-shake-hands-line text-6xl text-gray-200 mb-4 block"></i>
//               <p className="text-gray-400 text-xl font-serif">Awaiting your success story in this category.</p>
//             </motion.div>
//           )}
//         </div>
//       </section>

//       {/* Dynamic CTA */}
//       <section className="py-24 bg-white border-t border-gray-100">
//         <div className="max-w-5xl mx-auto px-6 text-center">
//           <h2 className="text-4xl md:text-5xl font-serif font-bold text-primary-dark mb-8">
//             Experience the <span className="italic text-primary-orange">Cherryhills</span> Standard
//           </h2>
//           <Link
//             to="/contact"
//             className="group inline-flex items-center bg-primary-dark text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-primary-orange transition-all duration-500 shadow-xl"
//           >
//             Start Your Journey 
//             <i className="ri-arrow-right-up-line ml-3 group-hover:rotate-45 transition-transform duration-300"></i>
//           </Link>
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default TestimonialsPage;






import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const categories = ['All', 'Investment Banking', 'Investment Management', 'Securities Trading', 'Fixed Income Fund', 'Short Term Bond Fund'];

const TestimonialCard = ({ testimonial, index }) => (
  <motion.div
    layout
    initial={{ opacity: 0, scale: 0.9 }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.9 }}
    transition={{ duration: 0.4, delay: index * 0.05 }}
    className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-2xl hover:border-primary-orange/30 transition-all duration-500 flex flex-col group"
  >
    <div className="mb-6">
      <div className="w-10 h-10 bg-primary-orange/10 rounded-full flex items-center justify-center group-hover:bg-primary-orange transition-colors duration-300">
        <i className="ri-double-quotes-l text-xl text-primary-orange group-hover:text-white"></i>
      </div>
    </div>

    <p className="text-gray-700 leading-relaxed text-lg mb-8 font-light italic">
      "{testimonial.feedback}"
    </p>

    <div className="mt-auto flex items-center space-x-4">
      <div className="relative">
        <img
          src={testimonial.avatar || `https://ui-avatars.com/api/?name=${testimonial.clientName}&background=fef3f2&color=f97316&bold=true`}
          alt={testimonial.clientName}
          className="w-14 h-14 rounded-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 border-2 border-transparent group-hover:border-primary-orange"
        />
      </div>
      <div>
        <h4 className="font-bold text-primary-dark text-base uppercase tracking-tight">
          {testimonial.clientName}
        </h4>
        {testimonial.clientCompany && (
          <p className="text-sm text-primary-orange font-medium">
            {testimonial.clientCompany}
          </p>
        )}
      </div>
    </div>
  </motion.div>
);

const TestimonialsPage = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await fetch('https://cherry.dealdrivetechnology.com/api/v1/public/testimonials');
        const result = await response.json();
        if (result.success) {
          // Filter only approved testimonials and sort by order
          const data = result.data
            .sort((a, b) => a.order - b.order);
          setTestimonials(data);
        }
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  // Note: The API current doesn't return 'category' or 'service' yet, 
  // but I've kept the filter logic ready for when you add it to the backend.
  const filteredData = activeFilter === 'All'
    ? testimonials
    : testimonials.filter(t => t.category === activeFilter);

  return (
    <div className="min-h-screen bg-gray-50/50">
      <Navbar />

      <section className="pt-40 pb-20 bg-primary-dark relative overflow-hidden">
        <div className="absolute top-0 right-0 w-1/3 h-full bg-primary-orange/10 blur-[120px] rounded-full translate-x-1/2"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl"
          >
            <h1 className="text-5xl md:text-7xl font-serif font-bold text-white mb-6">
              Voices of <span className="text-primary-orange">Trust.</span>
            </h1>
            <p className="text-xl text-gray-400 leading-relaxed">
              We measure our success by the legacies we help build. Read how our tailored financial strategies have impacted institutions and individuals globally.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-12 sticky top-20 z-30 bg-white/80 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between flex-wrap gap-6">
            <span className="text-xs font-bold uppercase tracking-widest text-gray-500">Filter by Expertise:</span>
            <div className="flex flex-wrap gap-2">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveFilter(cat)}
                  className={`px-6 py-2 rounded-full text-xs font-bold transition-all duration-300 ${
                    activeFilter === cat
                      ? 'bg-primary-dark text-white shadow-lg'
                      : 'bg-white text-gray-600 border border-gray-200 hover:border-primary-orange hover:text-primary-orange'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {loading ? (
            <div className="text-center py-40">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary-orange"></div>
              <p className="mt-4 text-gray-400">Loading stories of success...</p>
            </div>
          ) : (
            <>
              <motion.div 
                layout
                className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8"
              >
                <AnimatePresence>
                  {filteredData.map((testimonial, index) => (
                    <div key={testimonial._id} className="break-inside-avoid">
                      <TestimonialCard testimonial={testimonial} index={index} />
                    </div>
                  ))}
                </AnimatePresence>
              </motion.div>

              {filteredData.length === 0 && (
                <motion.div 
                  initial={{ opacity: 0 }} 
                  animate={{ opacity: 1 }} 
                  className="text-center py-40"
                >
                  <i className="ri-shake-hands-line text-6xl text-gray-200 mb-4 block"></i>
                  <p className="text-gray-400 text-xl font-serif">Awaiting your success story in this category.</p>
                </motion.div>
              )}
            </>
          )}
        </div>
      </section>

      <section className="py-24 bg-white border-t border-gray-100">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-primary-dark mb-8">
            Experience the <span className="italic text-primary-orange">Cherryhills</span> Standard
          </h2>
          <Link
            to="/contact"
            className="group inline-flex items-center bg-primary-dark text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-primary-orange transition-all duration-500 shadow-xl"
          >
            Start Your Journey 
            <i className="ri-arrow-right-up-line ml-3 group-hover:rotate-45 transition-transform duration-300"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TestimonialsPage;